
import { Check } from "@mui/icons-material"

import "./customicons.css"

export const CheckIcon = ({ disabled, onClick }) => {

  return (
   
    <div>
      <Check className= "iconCheck"  sx={{ fontSize: 25 }} onClick = {onClick}/>
    </div> 

  )
}
  




